import { LoadState } from "../../constants/enums";
import { IMetaData, IMetaDataState } from "./metaData.types";

export const initialMetaData: IMetaData = {
	user_uuid: "",
	module_name: "",
	config_value: {},
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
};

export const initialMetaDataState: IMetaDataState = {
	metaData: {
		data: initialMetaData,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
